frappe.ready(function () {
	const $form = $(".contact-form");
	const $btnSend = $(".contact-btn-send");

	$btnSend.off("click").on("click", function () {
		const email = $form.find('[name="email"]').val();
		const phone_no = $form.find('[name="phone-no"]').val();
		const message = $form.find('[name="detail"]').val();

		if (!email || !phone_no) {
			frappe.show_alert({
				title: __("Error"),
				message: __("Please enter your email, and phone number so that we can get back to you. Thanks!"),
				indicator: "red"
			}, 8);
			return false;
		}

		if (!validate_email(email)) {
			frappe.show_alert({
				title: __("Error"),
				message: __("You have entered an invalid email address. Please enter your valid email address so that we can reach out to you."),
				indicator: "red"
			}, 8);
			$form.find('[name="email"]').focus();
			return false;
		}

		frappe.send_message({
			args: { sender: email, message, phone_no },
			callback: r => {
				$btnSend.prop("disabled", true);
				if (r.message === "okay") {
					frappe.show_alert({
						title: __("Success"),
						message: __("We have received your message, thank you!"),
						indicator: "green"
					}, 8);
				} else {
					frappe.show_alert({
						title: __("Error"),
						message: __("There was an error sending your message, please try again later."),
						indicator: "red"
					}, 8);
					console.error(r.exc);
				}
				$form[0].reset();
			},
			error: () => {
				frappe.show_alert({
					title: __("Error"),
					message: __("There was an error sending your message, please try again later."),
					indicator: "red"
				}, 8);
			}
		}, this);

		return false;
	});

	// ---------------- HELPER ----------------
	const hover_and_touch = (element, callback) => {
		element.addEventListener("pointerenter", e => (e.pointerType === "mouse" || e.pointerType === "pen") && callback(e));
		element.addEventListener("pointerdown", e => (e.pointerType === "touch") && callback(e));
	};

	// ---------------- SWIPERS ----------------
	const initSwiper = (selector, config) => new Swiper(selector, config);

	// HERO SWIPER
	initSwiper(".hero-swiper", {
		loop: false,
		slidesPerView: 1,
		speed: 1600,
		autoplay: { delay: 2500, disableOnInteraction: false },
		pagination: { el: ".hero-swiper .swiper-pagination", clickable: true },
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		on: {
			init() {
				const firstVideo = this.slides[0].querySelector('.hero-section video[data-src]');
				if (firstVideo) {
					firstVideo.src = firstVideo.dataset.src;
					firstVideo.removeAttribute('data-src');
					firstVideo.load();
					firstVideo.play().catch(() => {});
				}
			},
			slideChangeTransitionStart() {
				const activeSlide = this.slides[this.activeIndex];
				const video = activeSlide.querySelector('.hero-section video[data-src]');
				if (video) {
					video.src = video.dataset.src;
					video.removeAttribute('data-src');
					video.load();
					video.play().catch(() => {});
				} else {
					const existingVideo = activeSlide.querySelector('.hero-section video');
					if (existingVideo) existingVideo.play().catch(() => {});
				}
			}
		}
	});

	// ---------------- HERO VIDEO LAZY LOADING ----------------
	document.querySelectorAll('.hero-section video[data-src]').forEach(video => {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					video.src = video.dataset.src;
					video.removeAttribute('data-src');
					video.load();
					video.play().catch(() => {});
					observer.unobserve(video);
				}
			});
		}, { threshold: 0.25 });
		observer.observe(video);
	});

	// COMPARISON SLIDER
	document.querySelectorAll(".comparison-slider").forEach(s => initSwiper(s, {
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 1000,
		autoplay: { delay: 300000, disableOnInteraction: false },
		pagination: { el: s.querySelector(".swiper-pagination"), clickable: true },
		watchSlidesVisibility: true,
		watchSlidesProgress: true
	}));

	// COMPARISON PANELS
	document.querySelectorAll(".comparison-images-container").forEach(panel => {
		const cols = panel.querySelectorAll(".comparison-col");
		cols.forEach(col => hover_and_touch(col, () => {
			cols.forEach(c => c.classList.remove("active"));
			col.classList.add("active");
		}));
	});

	// EXPERTISE SECTION
	document.querySelectorAll('.experties-section .card').forEach(card => {
		const img = card.querySelector('.change');
		hover_and_touch(card, () => img.src = img.dataset.gif);
		card.addEventListener("mouseleave", () => img.src = img.dataset.static);
	});

	// COMPLETED PROJECT SECTION
	document.querySelectorAll(".projects-group").forEach(group => {
		const items = group.querySelectorAll(".project-item");
		const swipers = Array.from(items, item => initSwiper(item.querySelector(".completed-project-slider"), {
			loop: false,
			speed: 800,
			slidesPerView: 1,
			watchOverflow: true,
			autoplay: item.classList.contains("active") ? { delay: 3000, disableOnInteraction: false } : false,
			pagination: { el: item.querySelector(".swiper-pagination"), clickable: true }
		}));

		let active_index = 0;
		items[active_index]?.classList.add("active");

		items.forEach((item, index) => hover_and_touch(item, () => {
			if (active_index === index) return;
			items[active_index].classList.remove("active");
			swipers[active_index].autoplay?.stop();
			active_index = index;
			item.classList.add("active");
			swipers[active_index].autoplay?.start();
		}));
	});

	// PROJECT GRID SLIDER
	initSwiper(".project-grid-slider", {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 10,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		watchOverflow: false,
		keyboard: { enabled: true },
		navigation: {
			nextEl: ".project-grid-slider .nav-arrow-button-right",
			prevEl: ".project-grid-slider .nav-arrow-button-left"
		},
		breakpoints: { 768: { spaceBetween: 15 }, 992: { spaceBetween: 25 } },
		on: { init() {
			const nav = this.navigation;
			if (this.slides.length <= 1) { nav.nextEl.style.display = 'none'; nav.prevEl.style.display = 'none'; }
		} }
	});

	// BUILT DIFFERENT SLIDER
	const built_different_list = document.querySelectorAll(".built-different-list li");
	let built_with_different_slider;

	built_with_different_slider = new Swiper(".built-with-different-slider", {
		loop: true,
		slidesPerView: 1,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		speed: 800,
		navigation: {
			nextEl: ".built-different-slide-buttons .nav-arrow-button-right",
			prevEl: ".built-different-slide-buttons .nav-arrow-button-left",
		},
		on: {
			init() {
				if (this.slides.length <= 1) {
					this.navigation.nextEl.style.display = "none";
					this.navigation.prevEl.style.display = "none";
				}
				built_different_list.forEach((l, i) => l.classList.toggle("active", i === this.realIndex));
			},
			slideChange() {
				built_different_list.forEach(l => l.classList.remove("active"));
				const active_slide = this.realIndex;
				built_different_list[active_slide]?.classList.add("active");
			}
		}
	});

	built_different_list.forEach((li, index) => {
		li.addEventListener("click", () => {
			built_different_list.forEach(l => l.classList.remove("active"));
			li.classList.add("active");
			built_with_different_slider.slideToLoop(index);
		});
	});
});
